/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_Step_TopicInputs */

const en_directory_ai_tools_studio_step_topic = /** @type {(inputs: Directory_Ai_Tools_Studio_Step_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's the rap about?`)
};

const zh_directory_ai_tools_studio_step_topic = /** @type {(inputs: Directory_Ai_Tools_Studio_Step_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这段说唱是关于什么的？`)
};

/**
* | output |
* | --- |
* | "What's the rap about?" |
*
* @param {Directory_Ai_Tools_Studio_Step_TopicInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_step_topic = /** @type {((inputs?: Directory_Ai_Tools_Studio_Step_TopicInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_Step_TopicInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_step_topic(inputs)
	return zh_directory_ai_tools_studio_step_topic(inputs)
});
export { directory_ai_tools_studio_step_topic as "directory.ai_tools.studio.step_topic" }